<template>
  <step :context="context" image="/images/rocket.svg" @back="$emit('back')" @submit="submit">
    <template #guideTitle>Let's get to know each other.</template>
    <template #guideDescription>
      Please enter your business details and contact information.
      We need this information to generate a user profile for you.
    </template>
    <template #formTitle>Business Details</template>
    <template #form>
      <v-form class="form" v-model="valid" ref="form">
        <!-- General -->
        <div class="general">
          <v-text-field
            v-model="model.general.businessName"
            label="Business Name"
            placeholder=" "
            :rules="[rules.required]"
          />
          <v-text-field
            v-model="model.general.contactName"
            label="Contact Name"
            placeholder=" "
            :rules="[rules.required]"
          />
          <v-text-field
            v-model="model.general.email"
            label="Contact Email"
            placeholder=" "
            :rules="[rules.required, rules.email]"
            validate-on-blur
          />
          <v-text-field
            v-model="model.general.phone"
            label="Phone No."
            placeholder=" "
            :rules="[rules.required]"
          />
          <v-text-field
            v-model="model.general.POS"
            label="POS"
            placeholder=" "
            :rules="[rules.required]"
          />
          <v-text-field
            v-model="model.general.numberOfLocations"
            label="No. of Locations"
            placeholder=" "
            :rules="[rules.required]"
          />
        </div>
        <!-- Loyalty program -->
        <v-radio-group
          v-model="model.existingLoyaltyProgram"
          label="Do you have an existing loyalty program?"
          row
          hide-details
          :rules="[rules.required]"
        >
          <v-radio label="Yes" value="other" />
          <v-radio label="No" value="no" />
          <div class="hint">We will migrate your existing members onto the new platform.</div>
        </v-radio-group>
      </v-form>
    </template>
  </step>
</template>

<script>
import Step from "../Step";
import CustomRadio from "../CustomRadio";
import displayMixin from "@/mixins/display";

const EMAIL_PATTERN = /\S+@\S+\.\S+/;

export default {
  props: ["context"],
  mixins: [displayMixin],
  components: {
    Step,
    CustomRadio
  },
  data() {
    return {
      valid: false,
      rules: {
        required: v => !!v || "Field is required",
        email: v => EMAIL_PATTERN.test(v) || "Email must be valid"
      },
      model: {
        general: {
          businessName: null,
          contactName: null,
          email: null,
          phone: null,
          numberOfLocations: null,
          POS: null
        },
        existingLoyaltyProgram: null,
        ...this.context.submittedData
      }
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate())
        this.$emit("done", { ...this.$data.model });
    }
  }
};
</script>

<style lang="scss" scoped>
.form {
  .general {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 60px;

    #app.mobile & {
      grid-template-columns: 1fr;
    }
  }

  #app.desktop & {
    ::v-deep .establishments {
      .v-input--radio-group__input > .v-label {
        margin-bottom: -4px !important;
      }
      .v-text-field {
        .v-input__slot {
          width: 200px;
        }
      }
    }
  }
}
</style>